import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  imports: [],
  template: `
    <a href="/" class="branding-link">
      <span class="brand-icon">
        <i class="ti ti-plant-2"></i>
      </span>
      <span class="brand-text">
        <span class="brand-name">AgriField</span>
        <span class="brand-badge">PRO</span>
      </span>
    </a>
  `,
  styles: [`
    .branding-link {
      display: flex;
      align-items: center;
      gap: 9px;
      text-decoration: none;
      white-space: nowrap;
      overflow: hidden;
    }
    .brand-icon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: linear-gradient(135deg, #2D6A4F, #52B788);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(45, 106, 79, 0.18);
    }
    .brand-icon i {
      font-size: 16px;
      color: #fff;
    }
    .brand-name {
      font-size: 15.5px;
      font-weight: 700;
      color: #1A1A1A;
      letter-spacing: -0.3px;
    }
    .brand-text {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .brand-badge {
      font-size: 7.5px;
      padding: 2px 5px;
      border-radius: 3px;
      background: #2D6A4F;
      color: #fff;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  `]
})
export class BrandingComponent {
  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}
}
